import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { PRODUCTS } from "@/data/content";

export default function Products() {
  return (
    <div data-testid="products-page" className="bg-white">
      <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 border-b border-slate-200">
        <div className="absolute inset-0 grid-bg opacity-50" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="overline mb-5">Our products</div>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.02] font-black text-slate-900">
              Software we build, <span className="text-[#1D4ED8]">own</span> and operate.
            </h1>
          </div>
          <div className="md:col-span-4">
            <p className="text-base md:text-lg text-slate-600 leading-relaxed font-light">
              KarnatakaCET and Anciens Network — products serving lakhs of students, alumni and institutions across India.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col gap-5">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
            >
              <Link
                to={`/products/${p.slug}`}
                data-testid={`product-row-${p.slug}`}
                className={`card-flat grid md:grid-cols-12 overflow-hidden group ${
                  i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
                }`}
              >
                <div
                  className="md:col-span-5 min-h-[240px] bg-cover bg-center relative"
                  style={{ backgroundImage: `url(${p.image})` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-transparent to-transparent" />
                  <div className="absolute bottom-4 left-5 font-mono text-[10px] tracking-[0.22em] uppercase text-white drop-shadow">
                    Product · 0{i + 1}
                  </div>
                </div>

                <div className="md:col-span-7 p-8 md:p-12 flex flex-col">
                  <div className="overline">In production</div>
                  <h3 className="mt-4 font-display text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
                    {p.name}
                  </h3>
                  <p className="mt-3 text-base text-slate-700">{p.tagline}</p>
                  <p className="mt-4 text-sm text-slate-600 leading-relaxed">
                    {p.summary}
                  </p>

                  <div className="mt-6 grid grid-cols-3 gap-4 max-w-md">
                    {p.metrics.map((m) => (
                      <div key={m.l}>
                        <div className="font-display text-2xl md:text-3xl font-black text-slate-900 tracking-tighter">
                          {m.v}
                        </div>
                        <div className="mt-1 font-mono text-[10px] tracking-[0.22em] uppercase text-slate-500">
                          {m.l}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-8 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.22em] uppercase text-slate-700 group-hover:text-[#1D4ED8] transition-colors">
                    Explore product <ArrowUpRight size={14} weight="bold" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
